export default __webpack_public_path__ + "static/media/insta_2.141f6359.svg";